import { useContext, useEffect, useState } from 'react';
import { getAppSettings } from '../services';
import { IAppSettings } from 'model/common/app-settings';
import { AppSettingsContext } from './context';
import { setApiBaseUrl } from 'features/common/auth/api-client';

export const useLoadAppSettings = (): IAppSettings | null => {
  const [settings, setSettings] = useState<IAppSettings | null>(null);

  useEffect(() => {
    const fetchSettings = async (): Promise<void> => {
      try {
        const settingsValue: IAppSettings = await getAppSettings();
        setSettings(settingsValue);
        setApiBaseUrl(settingsValue.api.url);
      } catch (e) {
        console.error(e);
      }
    };

    fetchSettings();
  }, []);

  return settings;
};

export const useAppSettings = (): IAppSettings | null => {
  return useContext(AppSettingsContext);
};
